import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WithdrawalReceiptPage } from './withdrawal-receipt.page';

const routes: Routes = [
  {
    path: '',
    component: WithdrawalReceiptPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WithdrawalReceiptPageRoutingModule {}
